import { useTranslation } from 'react-i18next';
import type { IMinimalSafetyEventForClient } from '@d-orca/shared/trusstor';
import styles from './mainView.module.css';

type IFloorAlertTooltipContentProps = {
  events: IMinimalSafetyEventForClient[];
};

/**
 * Body of the alert hover tooltip. One line per active safety event,
 * showing the translated `safetyViolationType`, separated by thin
 * dividers. Mirrors trusstor's `SafetyIcon.tsx:71-83`.
 */
export function FloorAlertTooltipContent({ events }: IFloorAlertTooltipContentProps) {
  const { t } = useTranslation();
  return (
    <ul className={styles.alertTooltipList}>
      {events.map((event, idx) => (
        <li
          key={`${event._id}-${idx}`}
          className={styles.alertTooltipItem}
          data-critical={event.isCritical || undefined}
        >
          {t(`monitor.safetyViolationType.${event.safetyViolationType}`)}
        </li>
      ))}
    </ul>
  );
}
